module.exports = __webpack_public_path__ + "static/media/joint_commission.b58feb5b.jpg";